import React, { Component } from 'react'
import s from './style.scss'
import { Query, Mutation } from "react-apollo";
import gql from "graphql-tag";
import classnames from 'classnames'

import Modal from '../../../components/Modal'
import UserSelection from '../../../components/UserSelection'
import { Button } from 'sofia-ui'
import axios from '../../../store/http/axios'
import urls from '../../../configs/urls'

import { Renderer } from 'sofia-commun'


const QUERY = gql`
query($uuid: String) {
  user(_id: $uuid) {
    id
    _id
    first_name
    last_name
    phone_number
    email
    role
  }
}
`

const ADMINS = gql`
{
  admins {
    id
    _id
    first_name
    last_name
    email
  }
}
`

class MessageDetails extends Component {

  state = {
    users: [],
    message: '',
    channel: {
      email: true,
      sms: false
    },
    preview: "EMAIL",
    admin: {},
    subject: 'Support'
  }

  insertText(value) {

    const values = {
      title : "{{#title}}Titre{{/title}}",
      title2 : "{{#title2}}Titre 2{{/title2}}",
      p : "{{#p}}{{/p}}",
      button : "{{button \"https://sofiatutors.com\" \"Texte\" }}",
      if : "{{#if condition}}{{/if}}"
    }

    let final = this.state.message

    if (this.input.selectionStart || this.input.selectionStart === '0') {
        var startPos = this.input.selectionStart;
        var endPos = this.input.selectionEnd;
        final = this.state.message.substring(0, startPos)
            + values[value]
            + this.state.message.substring(endPos, this.state.message.length);
    } else {
      final = this.state.message + values[value];
    }

    this.setState({ message: final })

  }

  newMessage = async () => {

    const { users, message, channel, admin, subject } = this.state

    await axios.post(urls.api + 'messaging/new', {
      admin,
      users,
      message,
      channel,
      subject
    })

    this.props.close()
    
  }

  render() {

      const { users, message, channel: { email, sms }, preview, subject } = this.state

      return <React.Fragment>

        <Modal
          title="New message"
          close={this.props.close}
          hide={this.props.hide}
          large
        >
          <div className={s.split}>
            <div className={s.left}>
              
              <div className={classnames(s.contacts, s.bb, s.padding)}>
                {users.map(({first_name, last_name, email, phone_number}, key) => 
                  <div key={key} className={s.contact}>
                    {first_name ? first_name + ' ' + last_name : email || phone_number}
                    <div className={s.remove} onClick={() => {
                      console.log('remove', key)
                      this.setState({ users: [...users.slice(0, key), ...users.slice(key+1)]})
                    }}>
                      <i className="fas fa-times"></i>
                    </div>
                  </div>)}
                <UserSelection onSelect={user => this.setState({ users: [...users, user] })} />
              </div>

              <div className={classnames('flex', 'f-space-between', s.bb, s.padding)}>
                <div>
                  <Button small color={email ? 'blue' : 'dark'} onClick={() => this.setState({ channel: { email: !email, sms } })} inline>Email</Button>
                  <Button small color={sms ? 'blue' : 'dark'} onClick={() => this.setState({ channel: { sms: !sms, email } })} inline>SMS</Button>
                </div>
                <div>
                  <Query query={ADMINS}>
                      {({ loading, error, data }) => {
                        return data && data.admins ?  data.admins.map(admin => <Button small color={admin.email === this.state.admin.email ? 'blue' : 'dark'} onClick={() => this.setState({ admin })} inline>{admin.first_name}</Button>) : null
                    }}
                  </Query>
                </div>
              </div>

              <div className={classnames(s.bb)}>
                <input
                  type="text"
                  className={classnames(s.subject, s.padding)}
                  placeholder="Sujet"
                  value={subject}
                  onChange={e => this.setState({ subject: e.target.value })}
                  />
              </div>

              <div className={classnames(s.bb)}>
                <textarea
                  className={classnames(s.textarea, s.padding)}
                  placeholder="Message"
                  value={message}
                  onChange={e => this.setState({ message: e.target.value })}
                  ref={node => { this.input = node }} />
              </div>

              <div className={classnames(s.padding)}>
                    <Button small inline color='dark' onClick={() => this.insertText('title')}>Title</Button>
                    <Button small inline color='dark' onClick={() => this.insertText('title2')}>Title 2</Button>
                    <Button small inline color='dark' onClick={() => this.insertText('p')}>Paragraph</Button>
                    <Button small inline color='dark' onClick={() => this.insertText('button')}>Button</Button>
                    <Button small inline color='dark' onClick={() => this.insertText('if')}>if</Button>
              </div>

            </div>
            <div className={classnames(s.right)}>

              <div className={s.tabs}>
                    <div className={classnames(s.tab, preview === "EMAIL" && s.activeTab)} onClick={() => this.setState({ preview: "EMAIL"})}>Email</div>
                    <div className={classnames(s.tab, preview === "SMS" && s.activeTab)} onClick={() => this.setState({ preview: "SMS"})}>SMS</div>
              </div>
              
              <div className={classnames(s.preview, preview === "SMS" && s.padding)}>
                <Query
                  query={QUERY}
                  variables={{
                    uuid: users[0] && users[0]._id
                  }}
                  >
                  {({ loading, error, data }) => {
                    let html = Renderer(preview, message, { user: data && data.user }, 'simple_fr', { to: data && data.user && data.user.email })
                    if (preview === "SMS") html = html.replace(/\n/ig, '<br />')
                    return <div dangerouslySetInnerHTML={{ __html: html }} />
                }}
                </Query>
              </div>
              <div className={classnames(s.buttons, s.padding)}>
                <Button color='green' onClick={this.newMessage} disabled={!users.length || !message.length || (!sms && !email) || !this.state.admin.email}>Envoyer</Button>
              </div>
            </div>
          </div>
        </Modal>

      </React.Fragment>
  }
}

export default MessageDetails



// WEBPACK FOOTER //
// ./src/containers/messages/New/index.js